import Ajax from "base/Ajax";
import {svg_include} from "index";

export default class CaseStudies {
    constructor($element) {
        this.$element = $element;
        this.$container = this.$element.find('.js-case-studies-container');
        this.$button = this.$element.find('.js-load-more');
        this.page = 1;
        this.request = null;
        this.bindEvents();
    }


    bindEvents() {
        this.$element.on('click', '.js-load-more', () => {
            this.loadCaseStudies();
        });
    }

    loadCaseStudies() {
        this.$button.addClass('btn--loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wp/v2', 'case-studies', {
            page: this.page
        });

        this.request.then((data) => {
            let headers = {};
            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }
            this.page++;
            this.updateCaseStudies(data, headers);
            this.$button.removeClass('btn--loading');
        }).catch((e) => {
            console.log(e);
            this.$button.removeClass('btn--loading');
        });
    }

    updateCaseStudies(data, headers) {
        if ('undefined' !== typeof headers['x-wp-totalpages']) {
            if (parseInt(headers['x-wp-totalpages']) <= this.page) {
                this.$button.hide();
            }
        }

        if ('undefined' !== typeof data && data.length > 0) {
            data.forEach((case_study) => {
                this.$container.append(this.buildCaseStudy(case_study));
            });
        }
    }

    buildCaseStudy(case_study) {
        return (
            eotwJSXFactory('div', {class: "columns__column"}, [
                eotwJSXFactory('div', {class: "card"}, [
                    eotwJSXFactory('div', {className: "card__image", unsafeHtml: 'undefined' !== typeof case_study.hero_image ? case_study.hero_image : ''}),
                    eotwJSXFactory('div', {className: "card__body"}, [
                        eotwJSXFactory('h3', {className: "card__heading heading heading--3"}, [eotwJSXFactory('a', {href: 'undefined' !== typeof case_study.link ? case_study.link : '', className: "pseudo-link"}, ['undefined' !== typeof case_study.title.rendered ? case_study.title.rendered : 'N/A'])]),
                        eotwJSXFactory('p', null, ['undefined' !== typeof case_study.snippet ? case_study.snippet : 'N/A']),
                        eotwJSXFactory('div', {className: "card__icon-link icon-link"}, [
                            eotwJSXFactory('div', {className: "icon-link__icon", unsafeHtml: (svg_include('circle-arrow'))}),
                            "Read more"
                        ])
                    ])
                ])
            ])
        );
    }
}
